import React from 'react';
import { Row, Col } from 'reactstrap';

const IndexPage = () => (
  <React.Fragment>
    <Row className="h-100">
      <Col md="2" className="section-photo d-flex align-items-center">
        <img src="/images/me.jpg" alt="James Allardice" className="photo" />
      </Col>
      <Col md="10" className="section-content d-flex align-items-center">
        <div> {/* Necessary to group the content for flex alignment */}
          <h1>James Allardice</h1>
          <p className="profile">
            Co-founder of <a href="https://www.orangejellyfish.com">orangejellyfish</a>. Passionate about building things at scale, especially with JavaScript. International speaker and tech advocate. Open source maintainer and contributor.
          </p>
          <p className="social">
            <a href="https://twitter.com/james_allardice/" title="Follow me on Twitter">
              <span className="fa-stack fa-lg">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-twitter fa-stack-1x fa-inverse" />
              </span>
            </a>
            <a href="https://linkedin.com/in/jamesallardice/" title="Connect with me on LinkedIn">
              <span className="fa-stack fa-lg">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-linkedin fa-stack-1x fa-inverse" />
              </span>
            </a>
            <a href="https://github.com/jamesallardice/" title="See my code on GitHub">
              <span className="fa-stack fa-lg">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-github fa-stack-1x fa-inverse" />
              </span>
            </a>
          </p>
        </div>
      </Col>
    </Row>
  </React.Fragment>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js